import { graphql } from "gql";

const CREATE_INVITE_MUTATION = graphql(`
  mutation CreateInvite($input: CreateInviteInput!) {
    createInvite(input: $input) {
      ...Invite
    }
  }
`);

export default CREATE_INVITE_MUTATION;
